import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "pr-2" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "pt-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_memoru_content_card = _resolveComponent("memoru-content-card")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_breadcrumbs, {
      items: [{ title: 'アルバム一覧', href: '/memoru/top', color:'primary' }, { title: '' }],
      class: "px-0"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.available && _ctx.album)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 0,
              color: "success",
              variant: "flat"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode(" 公開中 ", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_chip, {
              key: 1,
              color: "error"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("非公開中", -1)
              ]))]),
              _: 1
            }))
      ]),
      _createElementVNode("h3", null, _toDisplayString(_ctx.album ? _ctx.album.title : ""), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_checkbox, {
        modelValue: _ctx.bulkDelFlg,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bulkDelFlg) = $event)),
        label: "一括削除モード",
        "hide-details": "",
        density: "compact",
        color: "primary",
        class: "mr-4"
      }, null, 8, ["modelValue"]),
      (_ctx.bulkDelFlg)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            onClick: _ctx.bulkDeleteContent,
            color: "error"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" 一括削除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _cache[29] || (_cache[29] = _createTextVNode("  ", -1)),
      (!_ctx.bulkDelFlg)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateDialog = true)),
            color: "primary",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("mdi-cog", -1)
                ]))]),
                _: 1
              }),
              _cache[28] || (_cache[28] = _createTextVNode(" 設定 ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.bulkDelFlg)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          class: "my-4",
          type: "info",
          color: "primary",
          variant: "outlined",
          density: "compact",
          style: {"font-size":"0.9rem"}
        }, {
          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
            _createTextVNode(" チェックボックスが表示されないアイテムは、購入済みのアイテムのため削除できません。 ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.bulkDelFlg)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "mt-4",
          variant: "flat",
          color: "grey-lighten-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[31] || (_cache[31] = _createElementVNode("h5", null, "カテゴリ", -1)),
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.searchFilters.category,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.category) = $event)),
                          items: _ctx.multimediaCategoryType,
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          color: "primary"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[32] || (_cache[32] = _createElementVNode("h5", null, "売上枚数(下限)", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.searchFilters.purchasedCountMin,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.purchasedCountMin) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          suffix: "枚",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[33] || (_cache[33] = _createElementVNode("h5", null, "撮影開始日", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.searchFilters.dateFrom,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.dateFrom) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          type: "date",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[34] || (_cache[34] = _createElementVNode("h5", null, "撮影終了日", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.searchFilters.dateTo,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.dateTo) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          type: "date",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[37] || (_cache[37] = _createElementVNode("h5", null, "ステータス", -1)),
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.searchFilters.status,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.status) = $event)),
                          items: _ctx.statusOptions,
                          "item-title": "label",
                          "item-value": "value",
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          color: "primary"
                        }, {
                          selection: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                              (item.raw.color)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small",
                                    color: item.raw.color,
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                      _createTextVNode(" mdi-circle ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["color"]))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.title), 1)
                            ])
                          ]),
                          item: _withCtx(({ item, props }) => [
                            _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), _createSlots({ _: 2 }, [
                              (item.raw.color)
                                ? {
                                    name: "prepend",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        color: item.raw.color,
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                          _createTextVNode(" mdi-circle ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1040)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _cache[38] || (_cache[38] = _createElementVNode("h5", null, "シリアルNO", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.searchFilters.serialNumber,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.serialNumber) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          density: "compact",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.listContents,
                          loading: _ctx.loading,
                          color: "primary",
                          block: "",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode("検索 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          (_ctx.contents)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", null, "全" + _toDisplayString(_ctx.contents.total || 0) + "件", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.contents)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents.items, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      cols: "3",
                      key: i
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_memoru_content_card, {
                          onClick: ($event: any) => (_ctx.onClickContent(item)),
                          loading: _ctx.loading,
                          content: item,
                          bulkDelFlg: _ctx.bulkDelFlg,
                          bulkDelTarget: _ctx.bulkDelTarget,
                          "onUpdate:bulkDelTarget": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bulkDelTarget) = $event))
                        }, null, 8, ["onClick", "loading", "content", "bulkDelFlg", "bulkDelTarget"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.contents)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            class: "pt-4",
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
            length: Math.ceil(_ctx.contents.total / _ctx.searchFilters.limit),
            "active-color": "primary"
          }, null, 8, ["modelValue", "length"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.updateDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.updateDialog) = $event)),
      "max-width": "600px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode(" アルバム設定 ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.updateAlbumInput.title,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.updateAlbumInput.title) = $event)),
                              rules: [_ctx.required],
                              label: "タイトル*",
                              "hide-details": "",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.updateAlbumInput.year,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updateAlbumInput.year) = $event)),
                              rules: [_ctx.required],
                              label: "年度*",
                              "hide-details": "",
                              suffix: "年度",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.updateAlbumInput.nurseryClassIds,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.updateAlbumInput.nurseryClassIds) = $event)),
                              items: _ctx.classes,
                              "item-title": "className",
                              "item-value": "classId",
                              label: "クラス",
                              "hide-details": "",
                              variant: "outlined",
                              density: "compact",
                              multiple: "",
                              chips: ""
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              type: "date",
                              modelValue: _ctx.internalDateAfter,
                              "onUpdate:modelValue": [
                                _cache[13] || (_cache[13] = ($event: any) => ((_ctx.internalDateAfter) = $event)),
                                _ctx.updateCombinedDateTimeAfter
                              ],
                              label: "公開開始日",
                              "hide-details": "",
                              clearable: "",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              type: "time",
                              modelValue: _ctx.internalTimeAfter,
                              "onUpdate:modelValue": [
                                _cache[14] || (_cache[14] = ($event: any) => ((_ctx.internalTimeAfter) = $event)),
                                _ctx.updateCombinedDateTimeAfter
                              ],
                              label: "公開開始時",
                              "hide-details": "",
                              clearable: "",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            (_ctx.showAvailableBefore)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 0,
                                  type: "date",
                                  modelValue: _ctx.internalDateBefore,
                                  "onUpdate:modelValue": [
                                    _cache[15] || (_cache[15] = ($event: any) => ((_ctx.internalDateBefore) = $event)),
                                    _ctx.updateCombinedDateTimeBefore
                                  ],
                                  label: "公開終了日",
                                  "hide-details": "",
                                  clearable: "",
                                  variant: "outlined",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            (_ctx.showAvailableBefore)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 0,
                                  type: "time",
                                  modelValue: _ctx.internalTimeBefore,
                                  "onUpdate:modelValue": [
                                    _cache[16] || (_cache[16] = ($event: any) => ((_ctx.internalTimeBefore) = $event)),
                                    _ctx.updateCombinedDateTimeBefore
                                  ],
                                  label: "公開終了時",
                                  "hide-details": "",
                                  clearable: "",
                                  variant: "outlined",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.updateAlbumInput.comment,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.updateAlbumInput.comment) = $event)),
                              label: "コメント",
                              "hide-details": "",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateDialog = false)),
                          color: "grey",
                          variant: "text"
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.updateAlbum,
                          color: "primary",
                          loading: _ctx.loading,
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode("保存 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.detailDialog,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.detailDialog) = $event)),
      "max-width": "1200px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createTextVNode("詳細", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.selectedContent)
                  ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                      default: _withCtx(() => [
                        (_ctx.selectedContent.category == 'photo')
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "8" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_img, {
                                      height: "500",
                                      src: _ctx.selectedContent.downloadImageUrl
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.selectedContent.category == 'movie')
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "8" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("video", {
                                      width: "100%",
                                      height: "500",
                                      muted: "",
                                      controls: "",
                                      src: _ctx.selectedContent.downloadImageUrl
                                    }, null, 8, _hoisted_6)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            (_ctx.selectedContent.purchasedCount == 0)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  onClick: _ctx.deleteContent,
                                  loading: _ctx.loading,
                                  color: "error",
                                  variant: "flat",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                    _createTextVNode(" 削除 ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick", "loading"]))
                              : (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 1,
                                  loading: _ctx.loading,
                                  color: "grey",
                                  variant: "flat",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                    _createTextVNode(" 購入済み ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["loading"]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isDelDialog,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isDelDialog) = $event)),
      "max-width": "500px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex flex-column align-center text-center px-6 pt-6 pb-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "text-orange-lighten-2 mb-2",
                  size: "72px"
                }, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode(" mdi-alert-circle-outline ", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(" 選択した" + _toDisplayString(_ctx.bulkDelTarget.length) + "のアイテムを削除します。", 1),
                  _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                  _cache[48] || (_cache[48] = _createTextVNode(" 削除後この操作は取り消せません。", -1)),
                  _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                  _cache[50] || (_cache[50] = _createTextVNode(" 削除しますか？ ", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-space-between gs-4 px-6 pb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "grey-darken-1",
                  class: "px-6",
                  rounded: "md",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isDelDialog = false)),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode(" キャンセル ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "error",
                  class: "px-6 text-white",
                  rounded: "md",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.bulkDeleteContentBody())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                    _createTextVNode(" 削除 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}